import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';
import { CmhEnergyProductionConfigurationState } from './types';

export const actions: ActionTree<CmhEnergyProductionConfigurationState, RootState> = {}
